import PropTypes from 'prop-types'
import { PureComponent } from 'react'
import { Link } from 'react-router-dom'
import { Table } from 'semantic-ui-react'

import { Shield } from 'images'

class Avatar extends PureComponent {
  render() {
    const { align, className, printable, showName, team } = this.props

    if (!team) {
      return null
    }

    return (
      <Table.Cell className={className} collapsing textAlign={align} title={team.name}>
        {printable ? (
          <div className="flex items-center gap-1">
            <Shield size="1.50em" src={team.avatar} />
            {showName && team.nickname}
          </div>
        ) : (
          <Link className="flex items-center gap-2" to={`/sports/soccer/team/${team.id}`}>
            <Shield size="1.50em" src={team.avatar} />
            {showName && team.nickname}
          </Link>
        )}
      </Table.Cell>
    )
  }
}

Avatar.propTypes = {
  align: PropTypes.oneOf(['left', 'right', 'center']),
  className: PropTypes.string,
  printable: PropTypes.bool,
  showName: PropTypes.bool,
  team: PropTypes.object.isRequired,
}

Avatar.defaultProps = {
  align: 'left',
  className: null,
  printable: false,
  showName: false,
}

export default Avatar
